import React, { useEffect, useState } from "react";
import { Container, Col, Row, Form, Button,Modal,Image } from "react-bootstrap";
import Map from "../components/Map";
import { useNavigate } from "react-router-dom";
import { apiUrl } from "../commons/inFormTypes";
import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Ripples from 'react-ripples';
import Loaders from '../components/Loaders';
import logo1 from '../assets/img/alert8.png'
import PuffLoader from "react-spinners/PuffLoader";


function MainAddress() {
  let [lat, setLat] = useState(51.338097);
  let [log, setLog] = useState(35.699739);
  let [searchClicked, setSearchClicked] = useState(false);
  let [loading, setLoading] = useState(false);
  let [color, setColor] = useState("#899097");
  const [loadMap, setLoadMap] = useState(false)
  const [ listLocations, setListLocations ] = useState([]);
  const [search, setSearch] = useState(false);
  const [show, setShow] = useState(false);
  const [Stchange, setstchange] = useState(false);
  const [snip, setSnip] = useState(false); 
  const [seenFile, setSeenFile] = useState([]);
  const [seenLocations, setSeenLocations] = useState([]);
  const [areaId, setAreaId] = useState(0);
  const [locId, setLocId] = useState(0);
  const [areaText, setAreaText] = useState(0);
  const [address, setAddress] = useState("");
  const [selectAddress, setSelectAddress] = useState("0");
  const [selectareaId, setSelectareaId] = useState();
  const [selectareaTittle, setselectareaTittle] = useState("");
  const [toggle, setToggle] = useState(false);
  const navigate = useNavigate();
  const userToken = localStorage.getItem("user_token");
  const mstr = JSON.parse(localStorage.getItem("Master"));

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    
    if (userToken == null) {
      navigate("/");
    } else {
      if (seenLocations === []) {
        setToggle(false);
      } else {

        const axios = require("axios");
        axios
          .post(apiUrl + "Get_ListArea")
          .then((res) => {
            if (res.data.result === "true") {
              setSeenFile(res.data.data);
            } else {
            }
          })
          .catch(function (error) {
            if (error.response) {
              toast.error(error.response.data.message, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }
          });

        // const axios = require("axios");
        axios
          .post(apiUrl + "Get_ListLocation", {
            TokenId: userToken,
          })
          .then((res) => {
            if (res.data.result === "true") {
              setSeenLocations(res.data.data);
            } else {
            }
          })
          .catch(function (error) {
            if (error.response) {
              toast.error(error.response.data.message, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }
          });

      }
    }

  }, [Stchange]);

  const newLocationHandler = () => {
    setToggle(true);
    setSearchClicked(!searchClicked);

  }

  const submitHandler = () => {

    if (areaId == 0 || address == "") {
      toast.error("لطفا اطلاعات خود  را وارد کنید", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      setToggle(false);
      const axios = require("axios");
      setSnip(true);
      axios
        .post(apiUrl + "Insert_Location", {
          Type_Area: areaText,
          Type_Area_Id: areaId,
          Address: address,
          TokenId: userToken,
        })
        .then((res) => {
          setSnip(false);
          if (res.data.result === "true") {
            if (Stchange)
              setstchange(false)
            else
              setstchange(true)

          } else {
          }
        })
        .catch(function (error) {
          if (error.response) {
            toast.error(error.response.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });
    }
  }

  const selectAreaHandler = (e) => {
    setAreaId(e.target.value);
    setAreaText(e.target.options[e.target.selectedIndex].text);
  }

  const RadioHandlerChange = (val, Type_Area, Address, Type_Area_Id) => {
    setLocId(val)
    setSelectareaId(Type_Area_Id)
    setselectareaTittle(Type_Area)
    setSelectAddress(Address)

  }

  const removeHandler = (id) => {
    setShow(false);
    const axios = require("axios");
    axios
      .post(apiUrl + "DeleteArea", {
        Locid: id,
        TokenId: userToken,
      })

      .then((res) => {
        if (res.data.result === "true") {

          if (Stchange)
            setstchange(false)
          else
            setstchange(true)

        } else {
        }
      })
      .catch(function (error) {
        if (error.response) {
          toast.error(error.response.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      });
  }

  const cancelHandler = () => {
    setToggle(false);
    setAddress("");
    setAreaId(0);
    setAreaText("");
  }

  const HandleChange = (e) => {
    setAddress(e.target.value);
    if (e.target.value.length > 2)
    {
    const axios = require("axios");
    setLoading(true);
    axios
    .post(apiUrl + "Get_NeshanAddress")
    .then((res) => {
      setLoading(false);
      if (res.data.result === "true") {
        if(res.data.data.items.length>0)
             setSearch(true);
             else
             setSearch(false);           
        setListLocations(res.data.data.items);
      } else {
      }
    })
    .catch(function (error) {
      if (error.response) {
        toast.error(error.response.data.message, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    });
  } else {
    setSearch(false)
  }
  };  

  // const HandleSearch = (address1,val) => {
  //   setAddress(address1);
  //   console.log(val)
  //   setSearch(false);
  // };

  const HandleSearch = (address1,latx,laty) => {  
    setLat(latx );
    setLog( laty);
    setSearchClicked(!searchClicked);
    setAddress(address1);
      setSearch(false);
  };

  return (
    <div>
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} lg={8} className="rgc-request p-4 rgc-profile ">
            <div className="d-flex rgc-title">
              <div className="rgc-title-point"></div>
              <h4>انتخاب آدرس <span>محل سکونت</span></h4>
            </div>
            <Row className="justify-content-center g-3">
              {seenLocations.map((data, index) => {
                return (

                  <Col xs={12} key={index}>
                    <Ripples className="rgc-ripple">
                      <Row className={locId === data.Locid.toString() ?
                        "justify-content-center g-0 rgc-station-time rgc-station-select"
                        : "justify-content-center g-0 rgc-station-time"}>
                        <Col xs={2}>
                          <div className="radio">
                            <input
                              type="radio"
                              value={data.Locid.toString()}
                              className="rgc-checkbox mt-2 me-2"
                              checked={locId === data.Locid.toString()}
                              onChange={(e) => RadioHandlerChange(e.target.value, data.Type_Area, data.Address, data.Type_Area_Id)}
                            />
                          </div>
                        </Col>

                        <Col xs={8} className="text-end rgc-address-text">
                          <span>{data.Type_Area}-{data.Address}</span>
                        </Col>

                        <Modal
                          show={show}
                          onHide={handleClose}
                          backdrop="static"
                          keyboard={false}
                        >
                          <Modal.Header closeButton>
                            <Modal.Title></Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <div className="d-flex flex-column text-center rgc-modal-content">
                              <div>
                                <Image src={logo1} alt="logo" />
                              </div>
                              <span>
                                آیا نسبت به لغو پذیرش اطمینان دارید؟
                              </span>
                            </div>
                          </Modal.Body>
                          <Modal.Footer className="rgc-modal-button">
                          <Button onClick={() =>  removeHandler(data.Locid)}>
                              بله</Button>
                            <Button onClick={handleClose}>
                              خیر
                            </Button>
                            
                          </Modal.Footer>
                        </Modal>


                        <Col xs={2} className="rgc-order-close">
                          <i className="fa-solid fa-circle-xmark" 
                            onClick={handleShow}
                          ></i>
                        </Col>
                      </Row>
                    </Ripples>
                  </Col>
                )
              })}

              <Col xs={5} md={4} className={toggle ? "d-none" : "d-block"}>
                <Button onClick={newLocationHandler} className="rgc-order-btns rgc-order-btn-sub" >
                  ثیت آدرس جدید
                </Button>
              </Col>


              <Col xs={12} className={toggle ? "d-block" : "d-none"}>
                <Row className="justify-content-center">
                  <Col xs={12}>
                    <Form.Group>
                      <Form.Label>منطقه</Form.Label>
                      <Form.Select
                         className="rgc-select"
                        value={areaId}
                        onChange={(e) => selectAreaHandler(e)}
                      >
                        <option key={0} value="0">
                          لطفا انتخاب کنید
                        </option>
                        {seenFile.map((data, index) => (
                          <option key={index} value={data.ParaCode}>
                            {data.Title}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>


                  <Col xs={12} className="rgc-map">
                    <Form.Group className="my-3 rgc-input-icons" controlId="exampleForm.ControlTextarea1">
                      <Form.Label>آدرس کامل</Form.Label>
                      <i className="fa-solid fa-signs-post"></i>
                      {/* <PuffLoader color={color} loading={loading} size={45} /> */}
                      <Form.Control
                        as="textarea"
                        rows={1}
                        placeholder="شرح آدرس کامل..."
                        className="rgc-profile-input"
                        value={address}
                        onChange={(e) => HandleChange(e)}
                      />
                    </Form.Group>
                    {/* {search && (
                        <div className="rgc-search-input">
                          <ul>
                            {listLocations.map((item,index) => (
                              <li
                                key={index}
                                onClick={() =>
                                  HandleSearch(item.region+' '+item.address,item.location.x,item.location.y)
                                }
                              >
                                {" "}
                                {item.region+' '+item.address}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )} */}

                  </Col>
                  {/* <Col xs={12} className="text-center" style={{ zIndex: "0" }}>
                    <Map lat1={lat} lng1={log} mapLoad1={searchClicked} />
                  </Col> */}

                  <Col xs={6} md={4} className="text-center pt-4">
                    <Button onClick={submitHandler} className="rgc-order-btns rgc-order-btn-sub" >
                      <Loaders loads={snip} />
                      <span>ثبت و ذخیره موقعیت</span>
                    </Button>
                  </Col>

                  <Col xs={6} md={4} className="text-center pt-4">
                    <Button onClick={cancelHandler} className="rgc-order-btns rgc-order-btn-sub" >
                      <Loaders loads={snip} />
                      <span>انصراف</span>
                    </Button>
                  </Col>
                  
                </Row>
              </Col>

            </Row>
          </Col>

        </Row>
      </Container>
    </div>
  );
}

export default MainAddress;
